import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import uploadPhoto from "../../Image/upload 1.png";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import "./Modal.css";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));

function LoinModal({ setLoginModalOpen }) {
  const classes = useStyles();
  return (
    <div className="modalBackground loginModalContainer">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setLoginModalOpen(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h1>Login</h1>
        </div>
        <div className="subtitle">
          <p>Please enter your login details</p>
        </div>
        <div className="body">
          <div>
            <div className="modalInput">
              <div className="login_modal_label_input">
                <label htmlFor="">Work Email *</label>
                <input type="text" />
              </div>
            </div>
            <div className="modalInput">
              <div className="login_modal_label_input">
                <label htmlFor="">APassword *</label>
                <input type="text" />
              </div>
            </div>
          </div>
        </div>
        <div className="signButtonBody">
          <div className="login-btn">
            <Button>Login</Button>
          </div>
          <Typography variant="h5" className="forgotPassword">
            Forgot Password?
          </Typography>
        </div>
        <div className="footer">
          <button>Dont have an account? Register here</button>
        </div>
      </div>
    </div>
  );
}

export default LoinModal;
